/**
 * Product Toppings Selector (assets/product-toppings.js)
 * Marcantonio Theme
 */
(function() {
  'use strict';

  function formatMoney(cents, formatString) {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(cents, formatString || window.theme.moneyFormat);
    }
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var format = formatString || '€ {{amount}}';

    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, '.');
      decimal = defaultOption(decimal, ',');

      if (isNaN(number) || number == null) return '0';

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    }

    switch (format.match(placeholderRegex) ? format.match(placeholderRegex)[1] : '') {
      case 'amount':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = (cents / 100).toFixed(2).replace('.', ',');
        break;
    }

    return format.replace(placeholderRegex, value);
  }

  function initToppingsSelector() {
    var containers = document.querySelectorAll('.product-toppings');
    if (!containers.length) return;

    containers.forEach(function(wrap) {
      if (wrap.dataset.tsInit === '1') return;
      wrap.dataset.tsInit = '1';

      var sectionId = wrap.dataset.sectionId;
      var moneyFormat = wrap.dataset.moneyFormat || (window.theme && window.theme.moneyFormat) || '€ {{amount}}';
      var productTitle = wrap.dataset.productTitle || document.title;
      var basePrice = parseInt(wrap.dataset.basePrice, 10) || 0;

      var form = wrap.closest('form') || document.getElementById('AddToCartForm-' + sectionId);
      var productSection = document.getElementById('ProductSection-' + sectionId) || wrap.closest('[data-section-type="product"]');
      var priceElement = document.getElementById('ProductPrice-' + sectionId);
      var stickyPriceElement = document.getElementById('js-sticky-price');
      var atcButton = form ? (form.querySelector('#AddToCart-' + sectionId) || form.querySelector('[name="add"]')) : null;

      var summaryWrap = wrap.querySelector('.js-ts-summary');
      var chipsContainer = wrap.querySelector('.js-ts-chips');
      var basePriceDisplay = wrap.querySelector('.js-ts-base-price-display');
      var toppingsPriceDisplay = wrap.querySelector('.js-ts-toppings-price-display');
      var totalPriceDisplay = wrap.querySelector('.js-ts-total-price-display');
      var clearButton = wrap.querySelector('.js-ts-clear');
      var totalChip = wrap.querySelector('.js-ts-total-count-chip');
      var totalCountSpan = wrap.querySelector('.js-ts-selected-count');

      var categories = wrap.querySelectorAll('.ts-category');
      var allCheckboxes = wrap.querySelectorAll('.js-ts-checkbox');

      // ─── Dropdown Accordion Toggle ───────────────────────────────────────
      categories.forEach(function(cat) {
        var headerBtn = cat.querySelector('.js-ts-toggle');
        if (!headerBtn) return;

        headerBtn.addEventListener('click', function(e) {
          e.preventDefault();
          var isOpen = cat.classList.contains('is-open');

          // Close other categories (accordion style)
          categories.forEach(function(otherCat) {
            if (otherCat !== cat) {
              otherCat.classList.remove('is-open');
              var otherBtn = otherCat.querySelector('.js-ts-toggle');
              if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
            }
          });

          // Toggle current category
          if (isOpen) {
            cat.classList.remove('is-open');
            headerBtn.setAttribute('aria-expanded', 'false');
          } else {
            cat.classList.add('is-open');
            headerBtn.setAttribute('aria-expanded', 'true');
          }
        });
      });

      // ─── Get Selected Toppings ──────────────────────────────────────────
      function getSelectedToppings() {
        var selected = [];
        allCheckboxes.forEach(function(cb) {
          if (cb.checked) {
            selected.push({
              variantId: parseInt(cb.value, 10),
              price: parseInt(cb.dataset.price, 10) || 0,
              title: cb.dataset.title || '',
              category: cb.dataset.category || '',
              categoryId: cb.dataset.categoryId || '',
              checkbox: cb
            });
          }
        });
        return selected;
      }

      // ─── Update UI and Prices ───────────────────────────────────────────
      function updateUI() {
        var selected = getSelectedToppings();
        var totalToppingsPrice = 0;
        var categoryCounts = {};

        selected.forEach(function(item) {
          totalToppingsPrice += item.price;
          categoryCounts[item.categoryId] = (categoryCounts[item.categoryId] || 0) + 1;
        });

        // Update each category card badge & subtitle
        categories.forEach(function(cat) {
          var catId = cat.dataset.categoryId;
          var count = categoryCounts[catId] || 0;
          var badge = cat.querySelector('.js-ts-cat-badge');
          var subtitle = cat.querySelector('.js-ts-cat-subtitle');

          if (count > 0) {
            cat.classList.add('has-selections');
            if (badge) {
              badge.textContent = count;
              badge.classList.remove('hide');
            }
            if (subtitle) {
              subtitle.textContent = count === 1 ? '1 selezionato' : count + ' selezionati';
            }
          } else {
            cat.classList.remove('has-selections');
            if (badge) {
              badge.classList.add('hide');
            }
            if (subtitle) {
              subtitle.textContent = 'Nessuna selezione';
            }
          }
        });

        // Update Option Row active classes
        allCheckboxes.forEach(function(cb) {
          var row = cb.closest('.ts-option-row');
          if (row) {
            row.classList.toggle('is-selected', cb.checked);
          }
        });

        // Update Header count chip
        if (totalChip && totalCountSpan) {
          if (selected.length > 0) {
            totalCountSpan.textContent = selected.length;
            totalChip.classList.remove('hide');
          } else {
            totalChip.classList.add('hide');
          }
        }

        // Grand total calculation (unit price)
        var grandTotal = basePrice + totalToppingsPrice;

        // Update Summary Card
        if (summaryWrap) {
          if (selected.length > 0) {
            summaryWrap.classList.remove('hide');

            // Render chips
            if (chipsContainer) {
              var chipsHtml = '';
              selected.forEach(function(item) {
                var pText = item.price > 0 ? '+ ' + formatMoney(item.price, moneyFormat) : 'Gratis';
                chipsHtml += '<span class="ts-chip">' +
                  item.title +
                  ' <span class="ts-chip__price">(' + pText + ')</span>' +
                  '<button type="button" class="ts-chip__remove js-ts-chip-remove" data-variant-id="' + item.variantId + '" title="Rimuovi">×</button>' +
                  '</span>';
              });
              chipsContainer.innerHTML = chipsHtml;
            }

            if (basePriceDisplay) {
              basePriceDisplay.textContent = formatMoney(basePrice, moneyFormat);
            }
            if (toppingsPriceDisplay) {
              toppingsPriceDisplay.textContent = '+ ' + formatMoney(totalToppingsPrice, moneyFormat);
            }
            if (totalPriceDisplay) {
              totalPriceDisplay.textContent = formatMoney(grandTotal, moneyFormat);
            }
          } else {
            summaryWrap.classList.add('hide');
          }
        }

        // Update displayed product price on page
        if (priceElement) {
          priceElement.innerHTML = formatMoney(grandTotal, moneyFormat);
        }
        if (stickyPriceElement) {
          stickyPriceElement.innerHTML = formatMoney(grandTotal, moneyFormat);
        }
      }

      // ─── Checkbox Change Listener ───────────────────────────────────────
      allCheckboxes.forEach(function(cb) {
        cb.addEventListener('change', function() {
          updateUI();
        });
      });

      // ─── Clear All / Chip Remove ────────────────────────────────────────
      if (clearButton) {
        clearButton.addEventListener('click', function(e) {
          e.preventDefault();
          allCheckboxes.forEach(function(cb) {
            cb.checked = false;
          });
          updateUI();
        });
      }

      if (chipsContainer) {
        chipsContainer.addEventListener('click', function(e) {
          var removeBtn = e.target.closest('.js-ts-chip-remove');
          if (!removeBtn) return;
          e.preventDefault();
          var vid = removeBtn.dataset.variantId;
          allCheckboxes.forEach(function(cb) {
            if (cb.value === vid) {
              cb.checked = false;
            }
          });
          updateUI();
        });
      }

      // ─── Listen to Variant Changes (Theme Events) ───────────────────────
      if (productSection && window.jQuery) {
        window.jQuery(productSection).on('variantChange variantPriceChange', function(e, variant) {
          var v = variant || (e && e.variant);
          if (v && typeof v.price !== 'undefined') {
            basePrice = v.price;
            wrap.dataset.basePrice = v.price;
            updateUI();
          }
        });
      }

      // Fallback listener on variant selector
      var variantSelect = form ? form.querySelector('[name="id"]') : null;
      if (variantSelect) {
        variantSelect.addEventListener('change', function() {
          setTimeout(function() {
            var selectedOption = variantSelect.options[variantSelect.selectedIndex];
            if (selectedOption && selectedOption.dataset.price) {
              basePrice = parseInt(selectedOption.dataset.price, 10);
            }
            updateUI();
          }, 50);
        });
      }

      // ─── Add to Cart Submission Handler ──────────────────────────────────
      function handleAddToCart(e) {
        var selected = getSelectedToppings();
        if (selected.length === 0) {
          // No toppings selected: allow default theme submit
          return true;
        }

        // Toppings are selected: intercept and add main product + toppings atomically
        e.preventDefault();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        else if (e.stopPropagation) e.stopPropagation();

        var mainVariantInput = form.querySelector('[name="id"]');
        var mainVariantId = mainVariantInput ? mainVariantInput.value : null;
        if (!mainVariantId) {
          alert('Errore: variante non trovata.');
          return false;
        }

        var qtyInput = form.querySelector('[name="quantity"]');
        var mainQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

        // Generate unique bundle identifier for this pizza/piadina + toppings combination
        var bundleId = 'topping_' + Date.now() + '_' + Math.random().toString(36).substring(2, 7);

        // Readable comma-separated string for checkout and invoice
        var toppingsSummary = selected.map(function(t) {
          return t.title + (t.price > 0 ? ' (+' + formatMoney(t.price, moneyFormat) + ')' : '');
        }).join(', ');

        // Collect existing form properties (if any)
        var mainProperties = {};
        var existingPropInputs = form.querySelectorAll('[name^="properties["]');
        existingPropInputs.forEach(function(inp) {
          var m = inp.name.match(/properties\[(.*?)\]/);
          if (m && m[1] && inp.value && m[1].charAt(0) !== '_') {
            mainProperties[m[1]] = inp.value;
          }
        });

        mainProperties['_topping_bundle_id'] = bundleId;
        mainProperties['_topping_role'] = 'parent';
        mainProperties['Toppings'] = toppingsSummary;

        // Main product line item
        var items = [
          {
            id: parseInt(mainVariantId, 10),
            quantity: mainQty,
            properties: mainProperties
          }
        ];

        // Each selected topping as linked line item
        selected.forEach(function(t) {
          items.push({
            id: t.variantId,
            quantity: mainQty,
            properties: {
              '_bundle_parent_id': bundleId,
              '_topping_role': 'topping',
              'Aggiunto a': productTitle
            }
          });
        });

        // Set submit button loading state
        if (atcButton) {
          atcButton.classList.add('is-loading');
          atcButton.setAttribute('disabled', 'disabled');
        }

        // Submit to Shopify Cart API
        fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
        .then(function(res) {
          if (!res.ok) {
            return res.json().then(function(err) { throw err; });
          }
          return res.json();
        })
        .then(function(addedData) {
          // Update mini-cart and cart drawer
          if (window.theme && window.theme.miniCart) {
            window.theme.miniCart.updateElements();
            window.theme.miniCart.generateCart();
          }

          var styleCart = window.jQuery ? window.jQuery('.js-mini-cart').attr('data-cartmini') : null;
          if (styleCart === 'true') {
            if (window.jQuery) {
              window.jQuery('.js-mini-cart').addClass('active');
            }
          } else if (window.theme && window.theme.alert) {
            var htmlAlert = '<div class="media mt-2 alert--cart">' +
              '<div class="media-body align-self-center">' +
              '<p class="m-0 font-weight-bold">' + productTitle + ' x ' + mainQty + '</p>' +
              '<div class="small text-muted font-italic">Extra: ' + toppingsSummary + '</div>' +
              '</div></div>';
            window.theme.alert.new(
              (window.theme.strings && window.theme.strings.addToCartSuccess) || 'Aggiunto al carrello!',
              htmlAlert,
              3500,
              'notice'
            );
          }

          // Trigger custom event for other plugins/listeners
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: addedData }));
        })
        .catch(function(err) {
          console.error('Toppings Add to Cart Error:', err);
          var msg = (err && (err.description || err.message)) || 'Si è verificato un errore durante l\'aggiunta al carrello.';
          if (window.theme && window.theme.alert) {
            window.theme.alert.new('', msg, 3500, 'warning');
          } else {
            alert(msg);
          }
        })
        .finally(function() {
          if (atcButton) {
            atcButton.classList.remove('is-loading');
            atcButton.removeAttribute('disabled');
          }
        });

        return false;
      }

      // Attach capture listener on form submit
      if (form) {
        form.addEventListener('submit', handleAddToCart, true);
      }
      if (atcButton) {
        atcButton.addEventListener('click', function(e) {
          var selected = getSelectedToppings();
          if (selected.length > 0) {
            handleAddToCart(e);
          }
        }, true);
      }

      // Initial UI calculation
      updateUI();
    });
  }

  // Initialize on DOM load and Shopify section load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToppingsSelector);
  } else {
    initToppingsSelector();
  }
  document.addEventListener('shopify:section:load', initToppingsSelector);
})();

